import { auctionDescriptionHtml } from "./auction-description-html.ts";

export function AuctionDescription({
  description,
  className,
  id,
}: {
  description: string;
  className?: string | undefined;
  id?: string | undefined;
}) {
  return (
    <div
      className={["lockerverse-auctions__description", className]
        .filter(Boolean)
        .join(" ")}
      // biome-ignore lint/security/noDangerouslySetInnerHtml: Auction description HTML is trusted content supplied by the backend; the SDK renders it unchanged.
      dangerouslySetInnerHTML={{
        __html: auctionDescriptionHtml(description),
      }}
      id={id}
    />
  );
}
